import { useParams } from "react-router";
import { DashboardUtils, LinkChainData } from "../../../dashboard_utils";
import { DashboardContainer } from "../base_components/dashboard_container";
import { useCurrentGuildData } from "../hooks/use_guild_data";
import { TimeFinderBase } from "./time_finder_base";
import { TimeFinderCreate } from "./time_finder_create";
import { TimeFinderList } from "./time_finder_list";
import { TimeFinderView } from "./time_finder_view";
import { TimeFinderEdit } from "./time_finder_edit";
import { useEffect } from "react";
import { setDocTitle } from "../../../web_ui";

export function TimeFinderDashboard(props: {
	type: "create" | "view" | "base" | "edit";
}) {
	const guild_data = useCurrentGuildData();

	const { instance_id } = useParams<{ instance_id: string }>();

	useEffect(() => {
		let action = "";
		switch (props.type) {
			case "create":
				action = "Time Finder Create";
				break;
			case "view":
				action = instance_id ? "Time Finder View" : "Time Finder List";
				break;
			case "edit":
				action = "Time Finder Edit";
				break;
			default:
				action = "Time Finder";
		}
		setDocTitle(`${action}`, guild_data?.name);
	}, [props.type, instance_id, guild_data]);

	const link_chain_data: LinkChainData[] = [
		DashboardUtils.GetGuildSelectionLinkChainData(),
		DashboardUtils.RenderGuildOptionSelectLinkChain(guild_data),
		DashboardUtils.RenderTimeFinderSelectionLinkChain(guild_data, "base"),
	];

	switch (props.type) {
		case "create":
			link_chain_data.push(
				DashboardUtils.RenderTimeFinderSelectionLinkChain(
					guild_data,
					"create"
				)
			);
			break;
		case "view":
			link_chain_data.push(
				DashboardUtils.RenderTimeFinderSelectionLinkChain(
					guild_data,
					"view"
				)
			);

			if (instance_id) {
				link_chain_data.push(
					DashboardUtils.RenderTimeFinderSelectionLinkChain(
						guild_data,
						"view",
						instance_id
					)
				);
			}
			break;
		case "edit":
			link_chain_data.push(
				DashboardUtils.RenderTimeFinderSelectionLinkChain(
					guild_data,
					"view"
				)
			);

			if (instance_id) {
				link_chain_data.push(
					DashboardUtils.RenderTimeFinderSelectionLinkChain(
						guild_data,
						"view",
						instance_id
					)
				);
			}
			// We don't break above
			link_chain_data.push(
				DashboardUtils.RenderTimeFinderSelectionLinkChain(
					guild_data,
					"edit",
					instance_id
				)
			);
			break;
	}

	return (
		<DashboardContainer
			title={
				<div className="flex items-center gap-4">
					<span>Time Finder</span>
					<span className="rounded bg-sesh-primary px-1.5 py-0.5 text-xs font-medium uppercase tracking-wider text-black">
						Beta
					</span>
				</div>
			}
			bread_crumbs={
				<DashboardUtils.RenderLinkChain
					link_chain_data={link_chain_data}
				/>
			}
		>
			{props.type === "base" && <TimeFinderBase />}
			{props.type === "create" && <TimeFinderCreate />}
			{props.type === "view" && !instance_id && <TimeFinderList />}
			{props.type === "view" && instance_id && (
				<TimeFinderView time_finder_id={instance_id} />
			)}
			{props.type === "edit" && instance_id && (
				<TimeFinderEdit time_finder_id={instance_id} />
			)}
		</DashboardContainer>
	);
}
